// @flow

/**
 * Module dependencies.
 */

import { branch } from 'core/utils/branch';
import { colors, defaultTransition, keyframes, states, units } from 'client/styles';
import { position, size, transparentize } from 'polished';
import styled from 'styled-components';

/**
 * Default theme color.
 */

const defaultColor = colors.brandPrimary;

/**
 * Export `LoadingButton` component.
 */

export const LoadingButton = styled.button`
  background-color: transparent;
  border-radius: 100px;
  border: 2px solid;
  display: inline-block;
  height: 48px;
  line-height: 27px;
  min-width: 170px;
  overflow: hidden;
  padding: ${units(1)} ${units(2)};
  position: relative;
  text-align: center;
  transition: all ${defaultTransition};
  white-space: nowrap;

  ${({ themeColor = defaultColor }) => `
    border-color: ${themeColor} !important;
    color: ${themeColor};
  `};

  &[disabled] {
    opacity: .5;
    pointer-events: none;
  }

  ${states.action`
    outline: none;
    cursor: pointer;
    text-decoration: none;
  `};

  ${({ themeColor = defaultColor }) => states.interaction`
    background-color: ${themeColor};
    color: ${colors.white};
    text-decoration: none;
  `};

  &:after {
    ${position('absolute', '4px', '0', '0', '0')}
    ${size('36px', '36px')};

    border-radius: 50%;
    border: 2px solid ${transparentize(0.75, colors.black)};
    content: '';
    display: block;
    margin: 0 auto;
    opacity: 0;
    overflow: hidden;
    transform: scale(0);
    transition-delay: 0s;
    transition-property: opacity, transform;
    transition: ${defaultTransition};
    z-index: 2;

    border-bottom-color: ${colors.white};
  }

  &:before {
    ${position('absolute', '0', '0', '0', '0')}

    border-radius: 48px;
    content: '';
    opacity: 0;
    transition: opacity ${defaultTransition};
    z-index: 1;

    ${({ themeColor = defaultColor }) => `
      background-color: ${themeColor};
      border-color: ${themeColor};
    `};
  }

  ${({ loading }: Object): string => branch(loading, `
    min-width: 48px;
    padding-left: 0;
    padding-right: 0;
    width: 48px;

    &::after {
      opacity: 1;
      transform: scale(1);
      animation: ${keyframes.spin} .8s infinite linear;

      transition-delay: .2s;
    }

    &::before {
      opacity: 1;
    }
  `)}
`;



// WEBPACK FOOTER //
// ../src/client/components/core/buttons/loading-button.js